/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'es6-map/implement'
import 'babel-polyfill'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import traduzioni from './assets/Traduzioni'
import vMediaQuery from 'v-media-query'
import VueResource from 'vue-resource'
import 'innersvg-polyfill'
import Icon from 'vue-riva-style/icons/glyphicon'
import '../static/css/bootstrap.min.css'
// import Moment from 'moment'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'

import 'es6-promise/auto'
import Vuex from 'vuex'
import store from './components/Store'

Vue.component('icon', Icon)
Vue.component('v-select', vSelect)
Vue.component('multiselect', Multiselect)

Vue.use(Vuex)

Vue.use(VueResource)
Vue.use(vMediaQuery)
Vue.use(VueI18n)
// Vue.use(Moment)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: sessionStorage.hasOwnProperty('codLang') ? sessionStorage.getItem('codLang') : 'en_GB', // set locale
  fallbackLocale: sessionStorage.hasOwnProperty('codLang') ? sessionStorage.getItem('codLang') : 'en_GB', // default lang
  // locale: 'fr_FR',
  // fallbackLocale: 'fr_FR', // default lang
  messages: traduzioni,
  silentTranslationWarn: true
})

Vue.config.productionTip = false
Vue.http.options.credentials = true
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.http.interceptors.push((request, next) => {
  let makeID = (request.url.indexOf('?') > 0 ? '&markReqID=' + makeid() : '?markReqID=' + makeid())
  /*
  if (request.url.startsWith('{SPURL}')) {
    // Gestisco le chiamate di SharePoint
    request.url.replace('{SPURL}', '')
    request.url = process.env.baseUrlSP + request.url + makeID
  } else if (request.url.startsWith('{SPRING}')) {
    // Gestisco le chiamate di SharePoint
    request.url.replace('{SPRING}', '')
    request.url = process.env.baseUrlSpring + request.url + makeID
  } else {
    request.url = process.env.baseUrl + request.url + makeID
  }
  */
  if (request.url.startsWith('{SPURL}')) {
    // Gestisco le chiamate di SharePoint
    request.url.replace('{SPURL}', '')
    request.url = process.env.baseUrlSP + request.url + makeID
  } else {
    request.url = process.env.baseUrlSpring + request.url + makeID
  }
  let EXCLUDED_PATH = ['registrazione', 'pwdrecovery', 'support']
  // request.headers.set('Authorization', token)
  request.headers.map.Authorization = ['Bearer ' + sessionStorage.getItem('token')]
  // request.headers.map.Authorization = ['Bearer ' + token]
  next(function (response) {
    // modify response
    if (response.status === 401 || response.status === 403) {
      // console.log(EXCLUDED_PATH)
      // console.log(request.url, response.status, this.$route.name)
      if (EXCLUDED_PATH.indexOf(this.$route.name) === -1) {
        sessionStorage.setItem('token', '')
        sessionStorage.removeItem('token')
        sessionStorage.setItem('token_download', '')
        sessionStorage.removeItem('token_download')
        sessionStorage.setItem('menu', '')
        sessionStorage.removeItem('menu')
        sessionStorage.setItem('Trasferte_form', '')
        sessionStorage.removeItem('Trasferte_form')
        sessionStorage.setItem('Trasferte_Aut_form', '')
        sessionStorage.removeItem('Trasferte_Aut_form')
        this.$router.push({ name: 'Login' })
      }
    } else if (response.status !== 201) {
      this.$store.commit('set', { key: 'token_dtUpdate', value: Math.round(Date.now() / 1000) })
    }
  })
})

function makeid() {
  for (var e = '', n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', i = 0; i < 5; i++) {
    e += n.charAt(Math.floor(Math.random() * n.length))
  }
  return e
}

Vue.mixin({
  methods: {
    isMobile() {
      let check = false
      if ((navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i)) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) check = true
      // console.log(navigator.userAgent)
      // console.log('check: ' + check)
      return check
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js